import {useEffect, useState} from "react";
import {SortablePartnerItem} from "./SortablePartnerItem.tsx";
import {PartnerDetail} from "../types/types.ts";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
  KeyboardSensor, DragEndEvent,
  TouchSensor
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import "../scss/user-selected-partner.scss";

type Props = {
  userSelectedPartners: PartnerDetail[];
  setUserSelectedPartners: (partners: PartnerDetail[]) => void;
}
const UserSelectedPartnersView: React.FC<Props> = ({userSelectedPartners, setUserSelectedPartners}) => {
  const [sortablePartners, setSortablePartners] = useState<PartnerDetail[]>([]);

  useEffect(() => {
    setSortablePartners(userSelectedPartners ?? [])
  }, [userSelectedPartners]);

  const sensors = useSensors(
    useSensor(TouchSensor),
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active.id !== over?.id) {
      setSortablePartners((items) => {
        const oldIndex = items?.findIndex((item) => item.id === active.id);
        const newIndex = items?.findIndex((item) => item.id === over?.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };
  const handlePartnerClick = (partner: PartnerDetail) => {
    if (userSelectedPartners.includes(partner)) {
      setUserSelectedPartners(userSelectedPartners.filter(p => p !== partner));
      return;
    }
    setUserSelectedPartners([...userSelectedPartners, partner]);
  }

  return (
    <>
      <section className="mb-5 user-selected-partners">
        <p className="font-yettel-bold mb-3">Omiljeni brendovi</p>
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={onDragEnd}
        >
          <SortableContext
            items={sortablePartners?.map((partner) => partner.id) ?? []}
            strategy={verticalListSortingStrategy}
          >
            <div className="partner-content">
              {sortablePartners?.map((partner) => (
                <SortablePartnerItem
                  key={partner.id}
                  id={partner.id}
                  partner={partner}
                  handlePartnerClick={handlePartnerClick}
                />
              ))}
            </div>
          </SortableContext>
        </DndContext>
      </section>
    </>
  )
}

export default UserSelectedPartnersView;
